import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDocumentSettings, IEventPurchase } from '../purchases.interface';
import { DocumentSettingService } from './document-setting.service';
import { DocumentValidator } from './document-setting.validator';
@Component({
  selector: 'pg-purchase-document-setting-selection',
  templateUrl: './document-setting.component.html'
})
export class DocumentSettingComponent implements OnInit {
  fg: FormGroup;
  @Output('stepsEmitter') stepsEmitter = new EventEmitter<IEventPurchase>();
  documentsType = ['BOLETA', 'FACTURA'];

  constructor(
    private fb: FormBuilder,
    private documentSettingService: DocumentSettingService
  ) {}

  ngOnInit() {
    this.documentSettingService.getData$().subscribe((data) => {
      if (Object.keys(data).length === 0) {
        this.fg = this.fb.group({
          documentType: [null, [Validators.required]],
          documentCode: [null, [Validators.required]],
          date: [null, [Validators.required]],
          time: [null, [Validators.required]]
        });
      } else {
        this.fg = this.fb.group({
          documentType: [data.documentType, [Validators.required]],
          documentCode: [data.documentCode, [Validators.required]],
          date: [data.date, [Validators.required]],
          time: [data.time, [Validators.required]]
        });
      }
      this.fg.addValidators(DocumentValidator.valideForm());
    });
  }

  nextPage() {
    this.documentSettingService.setData(this.fg.value as IDocumentSettings);
    this.stepsEmitter.emit({
      action: 'next',
      data: null
    } as IEventPurchase);
  }

  prevPage() {
    this.stepsEmitter.emit({
      action: 'prev',
      data: null
    } as IEventPurchase);
  }
}
